import { render } from "./DataProjectTemplates.vue?vue&type=template&id=1927ac49&lang=pug"
import script from "./DataProjectTemplates.vue?vue&type=script&lang=js"
export * from "./DataProjectTemplates.vue?vue&type=script&lang=js"

import "./DataProjectTemplates.vue?vue&type=style&index=0&id=1927ac49&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__